import Task from "../model/Task"
import data from "./data.json"

function fixTask(root) {
  for (let i = 0; i < root.children.length; ++i) {
    root.children[i] = Object.assign(new Task(), root.children[i]);
    fixTask(root.children[i]);
  }
}

let task = Object.assign(new Task(), data);
fixTask(task);
export {task, fixTask};
